module.exports = __webpack_public_path__ + "static/media/office-of-government-procurement.9dc68573.jpg";